import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=e0337b82"
var script = {}
import style0 from "./Legal.vue?vue&type=style&index=0&id=e0337b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports